export enum FiduciaryStep {
  Form,
  Result,
  Details,
}
